"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LabeledInput = require("./LabeledInput.styles");

var _idGenerator = _interopRequireDefault(require("../../../utils/idGenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A labeled version of our standard inputs including disabled and those with error states
 */
var LabeledInput = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(LabeledInput, _React$PureComponent);

  var _super = _createSuper(LabeledInput);

  function LabeledInput(props) {
    var _this;

    _classCallCheck(this, LabeledInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.inputRef.current.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      _this.inputRef.current.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "validateInput", function () {
      return _this.inputRef.current && _this.inputRef.current.validateInput();
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e, errors) {
      return _this.props.onClick && _this.props.onClick(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (e, errors) {
      return _this.props.onChange && _this.props.onChange(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (e, errors) {
      return _this.props.onBlur && _this.props.onBlur(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (e, errors) {
      return _this.props.onFocus && _this.props.onFocus(e, errors);
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e, errors) {
      return _this.props.onKeyDown && _this.props.onKeyDown(e, errors);
    });

    _this.inputRef = _react.default.createRef();
    return _this;
  }

  _createClass(LabeledInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          aligninput = _this$props.aligninput,
          autoFocus = _this$props.autoFocus,
          characterLimit = _this$props.characterLimit,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          disabled = _this$props.disabled,
          displayName = _this$props.displayName,
          errors = _this$props.errors,
          guide = _this$props.guide,
          id = _this$props.id,
          inputType = _this$props.inputType,
          label = _this$props.label,
          layout = _this$props.layout,
          mask = _this$props.mask,
          name = _this$props.name,
          validationRules = _this$props.validationRules,
          value = _this$props.value,
          leftIcons = _this$props.leftIcons,
          rightIcons = _this$props.rightIcons,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["aligninput", "autoFocus", "characterLimit", "className", "dataTestId", "disabled", "displayName", "errors", "guide", "id", "inputType", "label", "layout", "mask", "name", "validationRules", "value", "leftIcons", "rightIcons", "onChange", "onBlur", "onFocus", "onClick"]);

      return /*#__PURE__*/_react.default.createElement(_LabeledInput.StyledLabeledInput, {
        className: className,
        "data-test-id": dataTestId,
        layout: layout
      }, label && /*#__PURE__*/_react.default.createElement(_LabeledInput.StyledLabel, {
        idFor: id,
        dataTestId: "labeled-input-label",
        layout: layout
      }, label), /*#__PURE__*/_react.default.createElement(_LabeledInput.StyledInput, _extends({
        aligninput: aligninput,
        autoFocus: autoFocus,
        characterLimit: characterLimit,
        dataTestId: "labeled-input-input",
        disabled: disabled,
        displayName: displayName,
        errors: errors,
        guide: guide,
        inputType: inputType,
        layout: layout,
        mask: mask,
        name: name,
        id: id,
        value: value,
        validationRules: validationRules,
        leftIcons: leftIcons,
        rightIcons: rightIcons,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        ref: this.inputRef
      }, props)));
    }
  }]);

  return LabeledInput;
}(_react.default.PureComponent);

_defineProperty(LabeledInput, "propTypes", {
  /** Alignment of the input area - primarily used when doing split layouts */
  aligninput: _propTypes.default.oneOf([undefined, 'left', 'right', 'center']),

  /** Autofocus flag */
  autoFocus: _propTypes.default.bool,

  /** Optional limit on character length */
  characterLimit: _propTypes.default.number,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Flag used to disable the input */
  disabled: _propTypes.default.bool,

  /** Text used in error messages */
  displayName: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag used for inidcating an error state for the input */
  errors: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Provide a guide over the input that reflects the required format (defaults to false) */
  guide: _propTypes.default.bool,

  /** standard id field */
  id: _propTypes.default.string,

  /** Used to indicate the type of input */
  inputType: _propTypes.default.oneOf([undefined, 'email', 'number', 'password', 'state', 'tel', 'text', 'zipcode']),

  /** Text value of the Label */
  label: _propTypes.default.string,

  /** Layout modifier */
  layout: _propTypes.default.oneOf([undefined, 'split']),

  /** Mask for input overlay and character limit (defaults to false) */
  mask: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.bool, _propTypes.default.func]),

  /** name reference for label htmlFor */
  name: _propTypes.default.string.isRequired,

  /** Rules for the field to validate against -- see: utils/inputValidator */
  validationRules: _propTypes.default.objectOf(_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]))),

  /** This is the storage location for the value of the input */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  // ICONS

  /** Icons or IconButtons to display to the left of the input field. */
  leftIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),

  /** Icons or IconButtons to display to the right of the input field. */
  rightIcons: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.element])),
  // EVENTS

  /** Function to invoke on a blur event */
  onBlur: _propTypes.default.func,

  /** Function to invoke on a change event */
  onChange: _propTypes.default.func,

  /** Function to invoke on a click event */
  onClick: _propTypes.default.func,

  /** Function to invoke on a focus event */
  onFocus: _propTypes.default.func,

  /** Function to invoke on a key down event */
  onKeyDown: _propTypes.default.func
});

_defineProperty(LabeledInput, "defaultProps", {
  aligninput: undefined,
  autoFocus: false,
  characterLimit: -1,
  className: '',
  disabled: false,
  displayName: '',
  errors: [],
  guide: false,
  id: (0, _idGenerator.default)(),
  inputType: 'text',
  label: '',
  layout: undefined,
  mask: false,
  validationRules: {},
  value: '',
  // icons
  leftIcons: [],
  rightIcons: [],
  // events
  onClick: function onClick() {},
  onChange: function onChange(e) {
    return e.target.value;
  },
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {}
});

var _default = LabeledInput;
exports.default = _default;